// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/fonts/OpenSans-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../src/assets/fonts/OpenSans-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../src/assets/fonts/OpenSans-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../src/assets/fonts/OpenSans-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../src/assets/fonts/OpenSans-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../src/assets/fonts/OpenSans-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../src/assets/fonts/OpenSans-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../src/assets/fonts/OpenSans-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../src/assets/fonts/OpenSans-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../src/assets/fonts/OpenSans-LightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../src/assets/fonts/OpenSans-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../src/assets/fonts/OpenSans-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../src/assets/fonts/OpenSans-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../src/assets/fonts/OpenSans-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Fonts*/
@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: normal;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff");
  font-weight: 300;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
/*Reset CSS*/
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  font-family: "Open Sans";
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
  font-family: "Open Sans";
}
body {
  line-height: 1;
  font-family: "Open Sans";
  color: #000;
  background: #f4f7fa;
  font-size: 10px;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
/*Hide Arrows From Input Number */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}
/*Placeholder Css*/

::placeholder {
  color: #c1c1c1;
}
/*Defaut Css*/
*,
*:before,
*:after {
  box-sizing: border-box;
  -ms-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}
.flex {
  display: flex;
  -webkit-display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
a {
  text-decoration: none;
}
.button {
  font-size: 12px;
  display: inline-block;
  background: #1984bc;
  color: #fff;
  border: 1px solid #1984bc;
  padding: 6px 30px;
  cursor: pointer;
  line-height: 1.2;
  font-weight: 700;
  -webkit-appearance: none;
  border-radius: 4px;
  transition: all 0.4s;
  -ms-transition: all 0.4s;
  -webkit-transition: all 0.4s;
  -moz-transition: all 0.4s;
}
.button:hover,
.button:focus {
  background: #296596;
}
.button--cancel {
  background: transparent;
  border: none;
  color: #222222;
}
.button--cancel:hover,
.button--cancel:focus {
  background: transparent;
  border: none;
  color: #222222;
}
h2 {
  font-size: 18px;
  color: #222222;
  font-weight: 700;
  line-height: 1.3;
}
h3 {
  font-size: 14px;
  color: #222222;
  font-weight: 700;
  margin-bottom: 15px;
  line-height: 1.3;
}

.field-label {
  font-size: 14px;
  color: #222222;
  font-weight: 600;
  margin-bottom: 5px;
  display: inline-block;
}
.addFieldButton {
  color: #0177b5;
  font-size: 12px;
  text-decoration: underline;
  line-height: 2;
  cursor: pointer;
  font-weight: 700;
  margin-bottom: 16px;
  display: inline-block;
}
.deleteIconWrapper {
  padding-top: 30px;
  padding-left: 20px;
}
.deleteIcon {
  cursor: pointer;
  height: 20px;
  width: 20px;
}
.stickySection {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 10;
}
.full-width {
  width: 100%;
}

.icon-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-right {
  display: flex;
  align-items: center;
  justify-content: right;
}
input[type="date"]::-webkit-scrollbar {
  display: none;
}
.section-heading-deleteIcon {
  display: flex;
  -webkit-display: flex;
  justify-content: space-between;
}
.section-heading-deleteIcon h3 {
  margin-bottom: 0;
}
.line-separation {
  border-bottom: 1px solid #edf0f2;
  margin-bottom: 20px;
  padding-bottom: 10px;
  position: relative;
}
.line-separation:after,
.line-separation:before {
  position: absolute;
  bottom: -1px;
  width: 20px;
  height: 1px;
  background: #edf0f2;
  content: "";
}
.line-separation:before {
  left: -20px;
}
.line-separation:after {
  right: -20px;
}
.tableAmount__label,
.tableAmount__remark {
  width: 33%;
  vertical-align: middle;
}
.accordionContent__tableAmountContent {
  padding: 20px 0px 20px 20px;
}
.tableAmount__label .row__label {
  font-size: 14px;
  color: #000000;
  line-height: 1.5;
  display: flex;
  -webkit-display: flex;
  height: 100%;
  align-items: center;
  padding-right: 20px;
}
.tableAmount__currYear,
.tableAmount__prevYear {
  width: 17%;
  vertical-align: middle;
}
.tableAmount .label-value-wrapper {
  margin-left: 0;
  margin-right: 10px;
  min-width: 100px;
  width: calc(100% - 10px);
  display: inline-block;
}
.tableAmount .label-value-wrapper input[type="text"] {
  padding: 10px;
}
.tableAmount__header th {
  font-size: 14px;
  color: #222222;
  font-weight: 700;
  line-height: 1.3;
  text-align: left;
  padding-bottom: 15px;
}
.tableAmount__rowLabel,
.tableAmount__rowRemark {
  width: 35%;
}
.tableAmount__rowPrevYear,
.tableAmount__rowCurrYear {
  width: 15%;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,QAAQ;AACR;EACE,wBAAwB;EACxB;0DACgE;EAChE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB;0DACgE;EAChE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB;0DAC+D;EAC/D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB;0DAC8D;EAC9D,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB;0DACqE;EACrE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB;2DACiE;EACjE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB;2DACkE;EAClE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA,YAAY;AACZ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,wBAAwB;AAC1B;AACA,gDAAgD;AAChD;;;;;;;;;;;EAWE,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,YAAY;AACd;AACA;;;;EAIE,WAAW;EACX,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA,iCAAiC;AACjC;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;AACA,kBAAkB;;AASlB;EACE,cAAc;AAChB;AACA,aAAa;AACb;;;EAGE,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;AACA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,MAAM;EACN,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;;EAEE,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;EAEE,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ","sourcesContent":["/*Fonts*/\n@font-face {\n  font-family: \"Open Sans\";\n  src: url(\"../src/assets/fonts/OpenSans-Italic.woff2\") format(\"woff2\"),\n    url(\"../src/assets/fonts/OpenSans-Italic.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  src: url(\"../src/assets/fonts/OpenSans-Medium.woff2\") format(\"woff2\"),\n    url(\"../src/assets/fonts/OpenSans-Medium.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  src: url(\"../src/assets/fonts/OpenSans-Light.woff2\") format(\"woff2\"),\n    url(\"../src/assets/fonts/OpenSans-Light.woff\") format(\"woff\");\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  src: url(\"../src/assets/fonts/OpenSans-Bold.woff2\") format(\"woff2\"),\n    url(\"../src/assets/fonts/OpenSans-Bold.woff\") format(\"woff\");\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  src: url(\"../src/assets/fonts/OpenSans-LightItalic.woff2\") format(\"woff2\"),\n    url(\"../src/assets/fonts/OpenSans-LightItalic.woff\") format(\"woff\");\n  font-weight: 300;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  src: url(\"../src/assets/fonts/OpenSans-Regular.woff2\") format(\"woff2\"),\n    url(\"../src/assets/fonts/OpenSans-Regular.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: \"Open Sans\";\n  src: url(\"../src/assets/fonts/OpenSans-SemiBold.woff2\") format(\"woff2\"),\n    url(\"../src/assets/fonts/OpenSans-SemiBold.woff\") format(\"woff\");\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n/*Reset CSS*/\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  vertical-align: baseline;\n  font-family: \"Open Sans\";\n}\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n  font-family: \"Open Sans\";\n}\nbody {\n  line-height: 1;\n  font-family: \"Open Sans\";\n  color: #000;\n  background: #f4f7fa;\n  font-size: 10px;\n}\nol,\nul {\n  list-style: none;\n}\nblockquote,\nq {\n  quotes: none;\n}\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: \"\";\n  content: none;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n/*Hide Arrows From Input Number */\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n/*Placeholder Css*/\n::-webkit-input-placeholder {\n  color: #c1c1c1;\n}\n\n:-ms-input-placeholder {\n  color: #c1c1c1;\n}\n\n::placeholder {\n  color: #c1c1c1;\n}\n/*Defaut Css*/\n*,\n*:before,\n*:after {\n  box-sizing: border-box;\n  -ms-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n}\n.flex {\n  display: flex;\n  -webkit-display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\na {\n  text-decoration: none;\n}\n.button {\n  font-size: 12px;\n  display: inline-block;\n  background: #1984bc;\n  color: #fff;\n  border: 1px solid #1984bc;\n  padding: 6px 30px;\n  cursor: pointer;\n  line-height: 1.2;\n  font-weight: 700;\n  -webkit-appearance: none;\n  border-radius: 4px;\n  transition: all 0.4s;\n  -ms-transition: all 0.4s;\n  -webkit-transition: all 0.4s;\n  -moz-transition: all 0.4s;\n}\n.button:hover,\n.button:focus {\n  background: #296596;\n}\n.button--cancel {\n  background: transparent;\n  border: none;\n  color: #222222;\n}\n.button--cancel:hover,\n.button--cancel:focus {\n  background: transparent;\n  border: none;\n  color: #222222;\n}\nh2 {\n  font-size: 18px;\n  color: #222222;\n  font-weight: 700;\n  line-height: 1.3;\n}\nh3 {\n  font-size: 14px;\n  color: #222222;\n  font-weight: 700;\n  margin-bottom: 15px;\n  line-height: 1.3;\n}\n\n.field-label {\n  font-size: 14px;\n  color: #222222;\n  font-weight: 600;\n  margin-bottom: 5px;\n  display: inline-block;\n}\n.addFieldButton {\n  color: #0177b5;\n  font-size: 12px;\n  text-decoration: underline;\n  line-height: 2;\n  cursor: pointer;\n  font-weight: 700;\n  margin-bottom: 16px;\n  display: inline-block;\n}\n.deleteIconWrapper {\n  padding-top: 30px;\n  padding-left: 20px;\n}\n.deleteIcon {\n  cursor: pointer;\n  height: 20px;\n  width: 20px;\n}\n.stickySection {\n  position: sticky;\n  position: -webkit-sticky;\n  top: 0;\n  z-index: 10;\n}\n.full-width {\n  width: 100%;\n}\n\n.icon-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.icon-right {\n  display: flex;\n  align-items: center;\n  justify-content: right;\n}\ninput[type=\"date\"]::-webkit-scrollbar {\n  display: none;\n}\n.section-heading-deleteIcon {\n  display: flex;\n  -webkit-display: flex;\n  justify-content: space-between;\n}\n.section-heading-deleteIcon h3 {\n  margin-bottom: 0;\n}\n.line-separation {\n  border-bottom: 1px solid #edf0f2;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  position: relative;\n}\n.line-separation:after,\n.line-separation:before {\n  position: absolute;\n  bottom: -1px;\n  width: 20px;\n  height: 1px;\n  background: #edf0f2;\n  content: \"\";\n}\n.line-separation:before {\n  left: -20px;\n}\n.line-separation:after {\n  right: -20px;\n}\n.tableAmount__label,\n.tableAmount__remark {\n  width: 33%;\n  vertical-align: middle;\n}\n.accordionContent__tableAmountContent {\n  padding: 20px 0px 20px 20px;\n}\n.tableAmount__label .row__label {\n  font-size: 14px;\n  color: #000000;\n  line-height: 1.5;\n  display: flex;\n  -webkit-display: flex;\n  height: 100%;\n  align-items: center;\n  padding-right: 20px;\n}\n.tableAmount__currYear,\n.tableAmount__prevYear {\n  width: 17%;\n  vertical-align: middle;\n}\n.tableAmount .label-value-wrapper {\n  margin-left: 0;\n  margin-right: 10px;\n  min-width: 100px;\n  width: calc(100% - 10px);\n  display: inline-block;\n}\n.tableAmount .label-value-wrapper input[type=\"text\"] {\n  padding: 10px;\n}\n.tableAmount__header th {\n  font-size: 14px;\n  color: #222222;\n  font-weight: 700;\n  line-height: 1.3;\n  text-align: left;\n  padding-bottom: 15px;\n}\n.tableAmount__rowLabel,\n.tableAmount__rowRemark {\n  width: 35%;\n}\n.tableAmount__rowPrevYear,\n.tableAmount__rowCurrYear {\n  width: 15%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
